<script>
    import BaseDialog from './BaseDialog.svelte';
    import ServiceResponse from '../service_response.svelte';

    let {
        dialogRef = $bindable(),
        addWhich,
        addSadP2,
        addSadP3,
        addSadP2Message
    } = $props();

    function focus(x) { x.focus(); }
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-3xl" title="Automatic Speech Recognition">
    {#snippet children({ dialog })}
        <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div use:focus tabindex="0" onkeydown={() => null} class="p-6 min-h-96 overflow-auto">
            {#if addWhich === 'asr'}
                <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-6">
                    <ServiceResponse
                        p1={null}
                        p2={addSadP2}
                        p3={addSadP3}
                        m1={""}
                        m2={addSadP2Message}
                        m3={"creating segments..."}
                    />
                </div>
            {/if}
        </div>
    {/snippet}
</BaseDialog>
